import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { PromotionNotification } from '@bcraft-frontend-lib/promotions'
import { useFrameManager } from '@bcraft-frontend-lib/slots'

import { ROUTE_URLS } from 'router/routes'

import { libLanguages } from 'shared/locale'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLanguage } from 'features/userSettings/selectors'

import TopBannerHoc from 'components/HOC/TopBannerHoc/TopBannerHoc'

const BonusPromotionNotification = () => {
  const history = useHistory()
  const { count: framesCount } = useFrameManager()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const lang = useSelector(selectLanguage, shallowEqual)

  return (
    <PromotionNotification
      isAuth={isAuth}
      suppressNotification={framesCount > 0}
      currentLanguage={libLanguages[lang]}
      getGameTypeUrl={gameType => ROUTE_URLS.SLOTS(gameType)}
      getStatusUrl={ROUTE_URLS.PROFILE_PROMOTIONS_STATUS}
      navigate={to => history.push(to)}
      renderBanner={({ isOpen, onClose, allPromotionsIsExpired, children }) => (
        <TopBannerHoc
          isShowNotification={isOpen}
          onCloseBanner={onClose}
          allPromotionsIsExpired={allPromotionsIsExpired}
          needAuth>
          {children}
        </TopBannerHoc>
      )}
    />
  )
}

export default BonusPromotionNotification
